import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  timezones: []
}

export const mutations = {
  SET_TIMEZONES(state, timezones) {
    state.timezones = timezones
  },
  ADD_TIMEZONE(state, timezone) {
    state.timezones.push(timezone)
  },
  EDIT_TIMEZONE(state, timezone) {
    const index = state.timezones.findIndex(
      t => t.timezone_uuid === timezone.timezone_uuid
    )
    if (index !== -1) {
      state.timezones.splice(index, 1, timezone)
    }
  },
  DELETE_TIMEZONE(state, timezone_uuid) {
    const index = state.timezones.findIndex(
      t => t.timezone_uuid === timezone_uuid
    )
    if (index !== -1) state.timezones.splice(index, 1)
  }
}

export const actions = {
  fetchTimezones({ commit }, payload) {
    return ApiService.fetchTimezones(payload)
      .then(res => {
        const timezones = res.data.data
        commit('SET_TIMEZONES', timezones)
      })
      .catch(error => {
        throw error
      })
  },
  addTimezone({ commit }, payload) {
    return ApiService.addTimezone(payload)
      .then(res => {
        const timezone = res.data
        commit('ADD_TIMEZONE', timezone)
      })
      .catch(error => {
        throw error
      })
  },
  editTimezone({ commit }, payload) {
    return ApiService.editTimezone(payload)
      .then(res => {
        const timezone = res.data
        commit('EDIT_TIMEZONE', timezone)
      })
      .catch(error => {
        throw error
      })
  },
  deleteTimezone({ commit }, payload) {
    return ApiService.deleteTimezone(payload)
      .then(() => {
        commit('DELETE_TIMEZONE', payload.timezone_uuid)
      })
      .catch(error => {
        throw error
      })
  }
}
